/* eslint-disable no-var */
var GabalMap = (function () {
	"use strict";

	var map = null;
	var mapData = null;

	var layers = { image: null, blocks: null, open_shapes: null, lines: null, texts: null };
	var layerVisible = { image: false, blocks: true, open_shapes: true, lines: true, texts: true };

	// ── Helpers ──────────────────────────────────────────────────────────────

	function esc(s) {
		return String(s || "")
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;");
	}

	function popupHtml(title, sub) {
		return (
			'<div class="popup-title">' +
			esc(title) +
			"</div>" +
			(sub ? '<div class="popup-sub">' + esc(sub) + "</div>" : "")
		);
	}

	// ── GabalTextBox: custom L.Layer that positions a text box by map bounds ──

	var GabalTextBox = L.Layer.extend({
		initialize: function (data) {
			this._data = data;
		},

		onAdd: function (map) {
			this._map = map;
			this._el = L.DomUtil.create("div", "gm-text-box-overlay");
			this._buildContent();
			map.getPanes().overlayPane.appendChild(this._el);
			map.on("zoom viewreset moveend", this._update, this);
			this._update();
		},

		onRemove: function (map) {
			L.DomUtil.remove(this._el);
			map.off("zoom viewreset moveend", this._update, this);
		},

		_buildContent: function () {
			var t = this._data;
			var s = t.style || {};
			var fw = s.font_weight === "Bold" ? "700" : "400";
			var va = s.vertical_align || "middle";
			var ta = s.text_align || "center";
			var bg = s.background_color || "transparent";
			var bc = s.border_color;
			var bw = s.border_width || 0;

			var aiMap = { top: "flex-start", middle: "center", bottom: "flex-end" };
			var jcMap = { right: "flex-end", center: "center", left: "flex-start" };

			var el = this._el;
			el.style.display = "flex";
			el.style.alignItems = aiMap[va] || "center";
			el.style.justifyContent = jcMap[ta] || "center";
			el.style.overflow = "hidden";
			el.style.opacity = s.opacity !== undefined ? s.opacity : 1;
			el.style.background = bg;
			el.style.borderStyle = bw && bc ? "solid" : "none";
			el.style.borderColor = bc || "transparent";
			el.style.boxSizing = "border-box";

			var inner = document.createElement("div");
			inner.style.direction = "rtl";
			inner.style.unicodeBidi = "plaintext";
			inner.style.color = s.text_color || "#111827";
			inner.style.fontFamily = s.font_family || "'Segoe UI',Tahoma,Arial,sans-serif";
			inner.style.fontWeight = fw;
			inner.style.fontStyle = s.font_style || "normal";
			inner.style.textDecoration = s.text_decoration || "none";
			inner.style.textAlign = ta;
			inner.style.lineHeight = s.line_height !== undefined ? s.line_height : 1.2;
			inner.style.whiteSpace = s.white_space_mode || "pre-wrap";
			inner.style.width = "100%";
			inner.textContent = t.text_value || "";
			el.appendChild(inner);
			this._innerEl = inner;
		},

		_update: function () {
			if (!this._map || !this._el) return;
			var b = this._data.box;
			var s = this._data.style || {};
			var map = this._map;

			var tl = map.latLngToLayerPoint([b.y + b.height, b.x]);
			var br = map.latLngToLayerPoint([b.y, b.x + b.width]);

			var w = Math.max(1, br.x - tl.x);
			var h = Math.max(1, br.y - tl.y);
			var rot = parseFloat(s.rotation || 0);

			this._el.style.width = w + "px";
			this._el.style.height = h + "px";
			this._el.style.transformOrigin = "50% 50%";
			this._el.style.transform =
				"translate3d(" + tl.x + "px," + tl.y + "px,0)" + (rot ? " rotate(" + rot + "deg)" : "");

			var scale = map.getZoomScale(map.getZoom(), 0);
			var bw = s.border_width || 0;

			this._el.style.padding = (s.padding || 0) * scale + "px";
			this._el.style.borderWidth = bw ? bw * scale + "px" : "0";
			this._el.style.borderRadius = (s.border_radius || 0) * scale + "px";

			if (this._innerEl) {
				this._innerEl.style.fontSize = (s.font_size || 18) * scale + "px";
				this._innerEl.style.letterSpacing = (s.letter_spacing || 0) * scale + "px";
			}
		},

		getBounds: function () {
			var b = this._data.box;
			return L.latLngBounds([b.y, b.x], [b.y + b.height, b.x + b.width]);
		},
	});

	// ── Draw functions ────────────────────────────────────────────────────────

	function drawBlocks(blocks) {
		layers.blocks.clearLayers();
		blocks.forEach(function (b) {
			if (!b.points || b.points.length < 3) return;
			L.polygon(b.points, {
				color: b.style.border_color || "#111827",
				weight: b.style.weight || 2,
				fillColor: b.style.fill_color || "#f8fafc",
				fillOpacity: b.style.fill_opacity !== undefined ? b.style.fill_opacity : 1,
				smoothFactor: 0,
			})
				.bindPopup(popupHtml(b.block_name, b.block_type))
				.addTo(layers.blocks);
		});
	}

	function drawTexts(texts) {
		layers.texts.clearLayers();
		texts.forEach(function (t) {
			if (!t.box || !t.box.width || !t.box.height) return;
			new GabalTextBox(t).addTo(layers.texts);
		});
	}

	function drawLines(lines) {
		layers.lines.clearLayers();
		lines.forEach(function (l) {
			if (!l.points || l.points.length < 2) return;
			var opts = {
				color: l.style.line_color || "#111827",
				weight: l.style.weight || 2,
				opacity: l.style.opacity !== undefined ? l.style.opacity : 1,
				lineCap: "square",
				lineJoin: "miter",
			};
			if (l.style.dash_array) opts.dashArray = l.style.dash_array;
			L.polyline(l.points, opts)
				.bindPopup(popupHtml(l.line_name || "خط"))
				.addTo(layers.lines);
		});
	}

	function drawOpenShapes(shapes) {
		layers.open_shapes.clearLayers();
		shapes.forEach(function (o) {
			if (!o.points || o.points.length < 2) return;
			var opts = {
				color: o.style.line_color || "#111827",
				weight: o.style.weight || 3,
				opacity: o.style.opacity !== undefined ? o.style.opacity : 1,
				fill: false,
				lineCap: "square",
				lineJoin: "miter",
			};
			if (o.style.dash_array) opts.dashArray = o.style.dash_array;
			L.polyline(o.points, opts)
				.bindPopup(popupHtml(o.shape_name || "شكل مفتوح", o.shape_type))
				.addTo(layers.open_shapes);
		});
	}

	// ── Map init ──────────────────────────────────────────────────────────────

	function initMap(data) {
		mapData = data;
		var s = data.settings;

		map = L.map("map", {
			crs: L.CRS.Simple,
			minZoom: -3,
			maxZoom: 5,
			zoomSnap: 0.25,
			zoomDelta: 0.5,
			zoomControl: false,
			attributionControl: false,
		});

		L.control.zoom({ position: "bottomleft" }).addTo(map);

		var bounds = [
			[0, 0],
			[s.map_height, s.map_width],
		];

		if (s.show_reference_image_public && s.reference_image) {
			layers.image = L.imageOverlay(s.reference_image, bounds, { opacity: 1, zIndex: 1 });
		}
		layerVisible.image = false;
		_setBtn("image", false);

		map.fitBounds(bounds);

		layers.blocks = L.layerGroup().addTo(map);
		layers.open_shapes = L.layerGroup().addTo(map);
		layers.lines = L.layerGroup().addTo(map);
		layers.texts = L.layerGroup().addTo(map);

		drawBlocks(data.blocks || []);
		drawOpenShapes(data.open_shapes || []);
		drawLines(data.lines || []);
		drawTexts(data.texts || []);

		document.getElementById("map-title-badge").textContent = s.map_title || "";
		buildSearchIndex(data);
	}

	// ── Search ────────────────────────────────────────────────────────────────

	var searchIndex = [];

	function buildSearchIndex(data) {
		searchIndex = [];
		(data.blocks || []).forEach(function (b) {
			searchIndex.push({ type: "block", label: b.block_name, sub: b.block_type, ref: b });
		});
		(data.open_shapes || []).forEach(function (o) {
			if (o.shape_name)
				searchIndex.push({ type: "open_shape", label: o.shape_name, sub: o.shape_type, ref: o });
		});
		(data.texts || []).forEach(function (t) {
			if (t.box && t.box.width) {
				searchIndex.push({ type: "text", label: t.text_value || "(نص)", sub: "", ref: t });
			}
		});
		(data.lines || []).forEach(function (l) {
			if (l.line_name) searchIndex.push({ type: "line", label: l.line_name, sub: "", ref: l });
		});
	}

	var badgeLabel = { block: "قطعة", open_shape: "شكل", text: "نص", line: "خط" };

	function doSearch(q) {
		var resultsEl = document.getElementById("search-results");
		var noEl = document.getElementById("no-results");
		resultsEl.innerHTML = "";
		resultsEl.appendChild(noEl);

		if (!q) {
			resultsEl.style.display = "none";
			return;
		}

		var lower = q.toLowerCase();
		var hits = searchIndex
			.filter(function (i) {
				return i.label.toLowerCase().indexOf(lower) !== -1;
			})
			.slice(0, 10);

		if (!hits.length) {
			noEl.style.display = "block";
			resultsEl.style.display = "block";
			return;
		}

		noEl.style.display = "none";
		hits.forEach(function (item) {
			var div = document.createElement("div");
			div.className = "search-result-item";
			var badge = document.createElement("span");
			badge.className = "result-type-badge badge-" + item.type;
			badge.textContent = badgeLabel[item.type] || item.type;
			var name = document.createElement("span");
			name.textContent = item.label;
			div.appendChild(badge);
			div.appendChild(name);
			div.onclick = function () {
				flyTo(item);
			};
			resultsEl.appendChild(div);
		});
		resultsEl.style.display = "block";
	}

	function flyTo(item) {
		document.getElementById("search-results").style.display = "none";
		document.getElementById("search-box").value = item.label;
		var ref = item.ref;

		if (item.type === "text" && ref.box) {
			var b = ref.box;
			map.fitBounds(
				[
					[b.y, b.x],
					[b.y + b.height, b.x + b.width],
				],
				{ padding: [40, 40] }
			);
			return;
		}
		if ((item.type === "line" || item.type === "open_shape") && ref.points && ref.points.length >= 2) {
			map.fitBounds(L.polyline(ref.points).getBounds(), { padding: [60, 60] });
			return;
		}
		if (item.type === "block" && ref.points && ref.points.length > 2) {
			map.fitBounds(L.polygon(ref.points).getBounds(), { padding: [60, 60] });
		}
	}

	// ── Layer toggle ──────────────────────────────────────────────────────────

	function toggleLayer(which) {
		layerVisible[which] = !layerVisible[which];
		var on = layerVisible[which];

		if (which === "image") {
			if (layers.image) {
				if (on) layers.image.addTo(map);
				else map.removeLayer(layers.image);
			}
		} else {
			if (layers[which]) {
				if (on) layers[which].addTo(map);
				else map.removeLayer(layers[which]);
			}
		}
		_setBtn(which, on);
	}

	function _setBtn(which, on) {
		var btn = document.getElementById("btn-" + which);
		if (btn) btn.classList.toggle("off", !on);
	}

	// ── Bootstrap ─────────────────────────────────────────────────────────────

	function init() {
		fetch("/api/method/custom_gabal_map.api.map.get_public_map_data?route=gabal-map")
			.then(function (res) {
				if (!res.ok) throw new Error("HTTP " + res.status);
				return res.json();
			})
			.then(function (data) {
				document.getElementById("loading-overlay").style.display = "none";
				if (data && data.message) {
					initMap(data.message);
				} else {
					showError("تعذّر تحميل بيانات الخريطة.");
				}
			})
			.catch(function (err) {
				document.getElementById("loading-overlay").style.display = "none";
				showError("خطأ: " + err.message);
			});

		var searchBox = document.getElementById("search-box");
		if (searchBox) {
			searchBox.addEventListener("input", function () {
				doSearch(this.value.trim());
			});
		}
		document.addEventListener("click", function (e) {
			var sc = document.getElementById("search-container");
			if (sc && !sc.contains(e.target)) {
				document.getElementById("search-results").style.display = "none";
			}
		});
	}

	function showError(msg) {
		var ol = document.getElementById("loading-overlay");
		ol.style.display = "flex";
		ol.innerHTML =
			'<p style="color:#fca5a5;font-size:15px;text-align:center;padding:20px">' + msg + "</p>";
	}

	return { init: init, toggleLayer: toggleLayer };
})();

window.GabalMap = GabalMap;

frappe.ready(function () {
	GabalMap.init();
});
